/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-copy-modal.component.html';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';

export interface CreativeCopyModalResult {
  destination: boolean;
  creativeId: string;
}

@Component({
  standalone: false,
  selector: 'adn-creative-copy-modal',
  template
})
export class CreativeCopyModalComponent implements OnInit {
  model: any;
  specifiedAdvertiser: any;
  onComplete: (result: CreativeCopyModalResult) => void;

  sourceName = '';
  destination = true;
  disabled = false;
  validationErrors: any[] = [];

  creative: any;

  private firstUiId = '';

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(CreativeResource) private readonly Creative: any,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.firstUiId = Uuid.generate();
    this.creative = _.cloneDeep(this.model);
    this.sourceName = this.model?.name || '';
    this.creative.name = nextCopyTitle(this.sourceName);
    this.creative.lineItems = this.creative.lineItems || {};
    if (_.isEmpty(this.creative.lineItems)) {
      this.creative.lineItems[this.firstUiId] = {uiId: this.firstUiId};
    }
    if (_.get(this.model, ['lineItem', 'id']) && !this.creative.lineItems[this.firstUiId].id) {
      this.creative.lineItems[this.firstUiId] = _.assign({uiId: this.firstUiId}, this.model.lineItem);
    }
  }

  addLineItem(): void {
    const uiId = Uuid.generate();
    this.creative.lineItems[uiId] = {uiId: uiId};
  }

  removeLineItem(index: string): void {
    delete this.creative.lineItems[index];
    if (_.isEmpty(this.creative.lineItems)) {
      this.addLineItem();
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  copyCreative(): void {
    this.disabled = true;
    this.validationErrors = [];
    this.adnModalLoading.applyModalLoading();

    const lineItemDests = _.uniqBy(_.filter(this.creative.lineItems, (li: any) => li.id), 'id');
    if (lineItemDests.length < 1) {
      lineItemDests.push({});
    }

    _.forEach(lineItemDests, (li: any, index: number) => {
      const newId = Uuid.generate();
      if (index === 0) {
        this.Creative.copyCreative(this.creative, li, newId, this.creative.userState).then(() => {
          this.adnModalLoading.removeModalLoading();
          this.onComplete?.({destination: this.destination, creativeId: newId});
          this.bsModalRef.hide();
        }, (errors: any) => {
          this.disabled = false;
          this.validationErrors = _.get(errors, ['data', 'errors'], []);
          this.adnModalLoading.removeModalLoading();
        });
      } else {
        this.Creative.copyCreative(this.creative, li, newId, this.creative.userState);
      }
    });
  }
}
